module.exports = __webpack_public_path__ + "images/mdj/members/resume/mobile/education-6fe17b122b6d3fe3d4afe074b4266a8a.png";